import React, { useContext, useEffect } from "react";
import UserContext from "./UserContext";

const Logout = () => {
  const [, setUser] = useContext(UserContext);

  useEffect(() => {
    setUser({});
  }, []);

  return (
    <section className="section">
      <div className="container is-max-desktop">
        <h1 className="title">Logged out</h1>
      </div>
    </section>
  );
};

export default Logout;
